import React from 'react';
import ContentLoader from 'react-content-loader';
import * as Styled from './ProductPanel.styles';

var ProductPanelSkeleton = function ProductPanelSkeleton(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 70 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 500 : _ref$width,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed,
      _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? '#f3f3f3' : _ref$primaryColor,
      _ref$secondaryColor = _ref.secondaryColor,
      secondaryColor = _ref$secondaryColor === void 0 ? '#ecebeb' : _ref$secondaryColor,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? true : _ref$loading;
  return /*#__PURE__*/React.createElement(Styled.Container, {
    isLoading: loading
  }, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor
  }, /*#__PURE__*/React.createElement("rect", {
    x: "85",
    y: "0",
    rx: "4",
    ry: "4",
    width: "200",
    height: "15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "85",
    y: "25",
    rx: "3",
    ry: "3",
    width: "105",
    height: "15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: width - 85,
    y: "0",
    rx: "3",
    ry: "3",
    width: "85",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: width - 55,
    y: "35",
    rx: "3",
    ry: "3",
    width: "55",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: width - 55,
    y: "50",
    rx: "3",
    ry: "3",
    width: "55",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "0",
    ry: "0",
    width: "70",
    height: "70"
  })));
};

export default ProductPanelSkeleton;